/* eslint-disable no-useless-catch */
import _ from 'lodash';
import * as reefService from '../core/reef';
import * as actions from '../redux/constants';
import {
  getGradebook,
  getGradebookInstructor,
  updateAlert,
  updateAllAverages,
  updateGradebook,
} from './gradebook';

function refreshGradebook(dispatch, getState, courseId) {
  const isGradebookV2Active = getState()?.gradebook?.isGradebookV2Active;
  if (isGradebookV2Active) {
    return dispatch(getGradebookInstructor(courseId));
  }
  return dispatch(getGradebook(courseId));
}

export const handleAlertReef = (info) => (dispatch) => {
  dispatch(
    updateAlert({
      show: true,
      type: info.type,
      dismissible: true,
      text: info.message,
    }),
  );
};

export const linkReefStudentAccount = (courseId, info) => async (dispatch) => {
  try {
    const user = await reefService.linkReefAccount(courseId, info);
    dispatch({
      type: actions.UPDATE_REEF_STATUS,
      payload: user,
    });
  } catch (error) {
    throw error;
  }
};

export const linkReefInstructorAccount =
  (courseId, info) => async (dispatch) => {
    try {
      const user = await reefService.linkReefAccount(courseId, info, true);

      dispatch({
        type: actions.UPDATE_REEF_STATUS,
        payload: user,
      });
    } catch (error) {
      throw error;
    }
  };

export const unlinkReefStudent = (courseId, info) => async (dispatch) => {
  try {
    const user = await reefService.unlinkReef(courseId, info);
    await dispatch(getGradebook(courseId));
    dispatch({
      type: actions.UPDATE_REEF_STATUS,
      payload: user,
    });
    dispatch(
      updateAlert({
        show: true,
        type: 'success',
        dismissible: true,
        text: 'Your iClicker account is now disconnected from achieve',
      }),
    );
  } catch (error) {
    dispatch(
      updateAlert({
        show: true,
        type: 'warning',
        dismissible: true,
        text: 'iClicker unlinking failed',
      }),
    );
    throw error;
  }
};

export const unlinkReefInstructor =
  (courseId, info) => async (dispatch, getState) => {
    try {
      const user = await reefService.unlinkReef(courseId, info, true);

      dispatch({
        type: actions.UPDATE_REEF_STATUS,
        payload: user,
      });

      const course = { course: { reef_course_id: null } };

      dispatch({
        type: actions.UPDATE_REEF_COURSE,
        payload: course,
      });

      refreshGradebook(dispatch, getState, courseId);
    } catch (error) {
      throw error;
    }
  };

export const isUserLinked = (courseId) => async (dispatch) => {
  try {
    dispatch({
      type: actions.UPDATE_REEF_STATUS_REQUEST,
    });
    const user = await reefService.isUserLinked(courseId);
    dispatch({
      type: actions.UPDATE_REEF_STATUS,
      payload: user.info,
    });
    dispatch({
      type: actions.UPDATE_REEF_STATUS_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: actions.UPDATE_REEF_STATUS_ERROR,
    });
    throw error;
  }
};

export const syncReefGrades =
  (courseId, info) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.APP_LOADING,
        payload: true,
      });

      const { assignments, iClickerStudentRosterMap } =
        await reefService.syncReefGrades(courseId, info);

      dispatch({
        type: actions.UPDATE_REEF_COURSE,
        payload: {
          assignments,
          iClickerStudentRosterMap,
        },
      });

      await refreshGradebook(dispatch, getState, courseId);
      await dispatch(updateAllAverages());

      dispatch({
        type: actions.APP_LOADING,
        payload: false,
      });
    } catch (error) {
      dispatch({
        type: actions.APP_LOADING,
        payload: true,
      });

      // force unlink if reef_mapping was deleted
      if (error.status === 401) {
        const course = { course: { reef_course_id: null } };
        const user = {
          info: {
            isReefLinked: false,
            reefProfile: null,
            reefCourseName: null,
          },
        };
        dispatch({
          type: actions.UPDATE_REEF_COURSE,
          payload: course,
        });
        dispatch({
          type: actions.UPDATE_REEF_STATUS,
          payload: user.info,
        });
        dispatch(
          updateGradebook({
            reefMenuOpen: false,
          }),
        );
      }

      dispatch({
        type: actions.APP_LOADING,
        payload: false,
      });

      throw error;
    }
  };

export const linkReefCourse =
  (courseId, info) => async (dispatch, getState) => {
    try {
      const reefCourse = await reefService.linkReefCourse(courseId, info);
      const reefCourseId = _.get(reefCourse, 'course.reef_course_id', null);
      const { assignments, iClickerStudentRosterMap } =
        await reefService.syncReefGrades(courseId, info);

      dispatch({
        type: actions.UPDATE_REEF_COURSE,
        payload: {
          reefCourseId,
          assignments,
          iClickerStudentRosterMap,
        },
      });

      dispatch(isUserLinked(courseId));
      refreshGradebook(dispatch, getState, courseId);

      dispatch({
        type: actions.APP_LOADING,
        payload: false,
      });
    } catch (error) {
      throw error;
    }
  };

export const getReefCourseList = (courseId) => async () => {
  try {
    const data = await reefService.getReefCourseList(courseId);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCreateCourse = (courseId) => async () => {
  try {
    const url = await reefService.getCreateCourse(courseId);
    return url;
  } catch (error) {
    throw error;
  }
};
